import { createCrudHooks } from '../../../shared/api/crud-hooks';
import { feriadosApi } from './api';
import type { FeriadoDto, FeriadoInput, FeriadoListItem } from './types';

export const feriadosHooks = createCrudHooks<
  FeriadoListItem & { id: string },
  FeriadoDto,
  FeriadoInput,
  string
>({
  queryKey: ['feriados'],
  api: feriadosApi,
});
